import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getTranslatedData } from '../../../localization';
import { useDeliveryColors } from '../../../hooks/useDeliveryColors';

const MenuBar = ({ menu, productCategories, selected, onSelect, isDelivery }) => {
  const { t } = useTranslation();
  const colors = useDeliveryColors();

  const scroller = useRef();
  const categoryRefs = useRef({}).current;

  useEffect(() => {
    const updateScrollPosition = (e) => {
      e.preventDefault();

      // eslint-disable-next-line no-undef
      document.getElementById('menu-bar').scrollLeft += e.deltaY;
    };

    if (scroller && scroller.current) {
      scroller.current.addEventListener('wheel', updateScrollPosition);

      return () => {
        if (scroller && scroller.current) {
          scroller.current.removeEventListener('wheel', updateScrollPosition);
        }
      };
    }

    return () => {};
  }, []);

  useEffect(() => {
    if (selected) {
      const categoryRef = categoryRefs[selected];

      if (categoryRef) {
        scroller.current.scroll({
          left: categoryRef.offsetLeft - 25,
          top: 0,
          behavior: 'smooth',
        });
      }
    }
  }, [selected]);

  const renderCategoryItem = (id, text, ind, totalItems) => {
    return (
      <button
        key={id}
        type="button"
        className={`text-primary border rounded-[50px]
          py-2 px-4  font-primaryMedium text-sm whitespace-nowrap
          ${selected === id ? 'border-primary' : 'border-transparent'}
          ${isDelivery && selected === id ? 'text-white bg-primary' : 'bg-transparent'}
          ${
            isDelivery && selected !== id
              ? 'hover:text-bland transition duration-300 ease-in-out'
              : ''
          }
          ${isDelivery && ind === 0 ? 'mr-1' : ''}
          ${isDelivery && ind === totalItems - 1 ? 'ml-1' : ''}
          ${isDelivery && ind > 0 && ind < totalItems - 1 ? 'mx-1' : ''}`}
        style={{
          background: isDelivery && selected === id ? colors.primary : undefined,
          borderColor: isDelivery && selected === id ? colors.primary : undefined,
        }}
        onClick={() => {
          const scrollerHeight = scroller.current.offsetHeight;
          onSelect(id, scrollerHeight);
        }}
        ref={(el) => {
          if (!el) {
            return;
          }

          categoryRefs[id] = el;
        }}
      >
        {id === '_other' ? t('products.categoryOther') : text}
      </button>
    );
  };

  return (
    <div
      id="menu-bar"
      ref={scroller}
      className={`overflow-x-auto w-full bg-white ${
        isDelivery ? 'py-4' : 'my-2 py-2'
      } text-center whitespace-nowrap scrollbar-h`}
    >
      <div className="inline-block">
        {!!menu &&
          menu.categories.map((category, ind) => {
            const imagesByLang = getTranslatedData(category.images) || [];

            if (!imagesByLang || imagesByLang.length === 0) {
              return null;
            }

            return renderCategoryItem(
              category.id,
              getTranslatedData(category.name),
              ind,
              menu.categories.length,
            );
          })}
        {!!productCategories &&
          productCategories.map((category, ind) => {
            return renderCategoryItem(
              category.id,
              getTranslatedData(category.name),
              ind,
              productCategories.length,
            );
          })}
      </div>
    </div>
  );
};

export default MenuBar;
